import { create, test, enforce } from 'vest';

export const validateChangePassword = create('ChangePasswordForm', (data) => {
    test('password', 'Current password is required.', () => {
        enforce(data.password)
            .isNotEmpty();
    });

    test('new_password', 'Can not be empty.', () => {
        enforce(data.new_password)
            .isNotEmpty();
    });

    test('new_password', 'Must be at least 6 characters long.', () => {
        enforce(data.new_password)
            .longerThanOrEquals(6);
    });

    test('new_password', 'Passwords do not match', () => {
        enforce(data.new_password)
            .equals(data.confirm_password);
    });

    test('confirm_password', 'Passwords do not match', () => {
        enforce(data.new_password)
            .equals(data.confirm_password);
    });
});

export const validateAcceptInvite = create('AcceptInviteForm', (data) => {
    test('fullname', 'Full name is required.', () => {
        enforce(data.fullname)
            .isNotEmpty();
    });

    test('password', 'Password is required.', () => {
        enforce(data.password)
            .isNotEmpty();
    });
});

export default validateChangePassword;
